import { LogInsightsView } from "../LogReviewerInsights/LogInsightsView";

/**
 * CISO Insights — the Division Head approval queue. Approves or rejects
 * justifications a Log Reviewer has already acknowledged.
 *
 * Body only: the page title, strapline and tab strip belong to the Change
 * Assurance Governance shell, which renders this through an <Outlet />.
 *
 * TODO(rbac): gate on the `log_review_ciso` permission once the Log Review
 * modules are added to RBAC_MATRIX.
 */
export const CisoLogReviewPage = () => <LogInsightsView role="approver" />;
